import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const Shock: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <g clipPath='url(#a)'>
        <path
          fill={props?.fill ?? '#1E1E1E'}
          d='M23.09.911c-1.727-1.727-4.647-.865-5.214 1.455l-.343-.343a.75.75 0 0 0-1.06 0L14.804 3.69a.75.75 0 0 0 0 1.06l.581.582-.606.606-.581-.581a.75.75 0 0 0-1.06 1.06c1.589 1.59 1.516 1.519 1.52 1.521.015.015-2.324-1.071-2.47-1.11-.742-.193-1.248.726-.718 1.256l1.521 1.522c-2.504-1.139-2.412-1.12-2.607-1.132a.75.75 0 0 0-.663 1.178c.055.08-.036-.018 1.604 1.62-2.447-1.111-2.333-1.062-2.337-1.062-.646-.296-1.307.37-.995 1.008.072.147.098.155.724.781l-.606.607-.581-.581a.75.75 0 0 0-1.061 0l-1.667 1.667a.75.75 0 0 0 0 1.06l.096.097-2.215 2.965c-2.516.347-3.596 3.448-1.77 5.274 1.83 1.83 4.927.738 5.273-1.771L9.152 19.1c.137.137.297.316.627.316a.75.75 0 0 0 .53-.219l1.667-1.667a.75.75 0 0 0 0-1.06l-.581-.582.606-.606.582.58a.75.75 0 1 0 1.06-1.06l-1.52-1.52c2.503 1.137 2.394 1.102 2.548 1.125.697.102 1.12-.714.678-1.228-.035-.042.073.068-1.56-1.565 2.577 1.171 2.457 1.155 2.724 1.131a.75.75 0 0 0 .584-1.12c-.073-.125-.01-.047-1.641-1.678 2.504 1.138 2.395 1.103 2.548 1.125a.75.75 0 0 0 .857-.805c-.029-.332-.184-.433-.798-1.047l.606-.606.582.58a.75.75 0 0 0 1.06 0l1.667-1.666a.75.75 0 0 0 0-1.061l-.343-.343c2.354-.576 3.157-3.511 1.455-5.214ZM4.248 22.027a1.606 1.606 0 0 1-2.274 0 1.606 1.606 0 0 1 0-2.274 1.61 1.61 0 0 1 2.274 0 1.61 1.61 0 0 1 0 2.274ZM22.029 4.245a1.61 1.61 0 0 1-2.273 0 1.607 1.607 0 1 1 2.274 0Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default Shock
